import React, { lazy } from 'react';
import {
	createUser,
	dashboardPagesMenu,
	// dashboardPagesRoles,
	demoPagesMenu,
	jobrequisitionMenu,
	jobDescriptionMenu,
	logoutMenu,
	pageLayoutTypesPagesMenu,
	profileMenu,
	userManagement,
	OfferGenerateMenu,
	OfferListMenu,
	dashboardMenu,
	interviewPanelMenu,
	FeedbackParameterList,
	FeedbackParameterMenu,
	roleCreationMenu,
	jobRequisitionFormMenu,
	ScheduledInterviewsMenu,
	interviewViewMenu,
	CandidateEvaluationMenu,
	CandidateApplicationHistory,
	AiVoiceInterview,
	CurrentOpeningsMenu,
	ReferCandidatesList,
	QuestionariesListMenu,
} from '../menu';
import Login from '../pages/presentation/auth/Login';
import Logout from '../pages/presentation/auth/Logout';

// import Role from '../pages/_layout/_asides/RolePage';
import RolePage from '../pages/Role_Layout/RolePage';
import path from 'path';
import UserCreate from '../pages/UserManagement/UserCreate';
import UserTable from '../pages/UserManagement/UserTable';
import { element } from 'prop-types';
import JobTemplate from '../pages/JD-template/JobTemplate';
import JobList from '../pages/JD-template/JobList';
import OfferGenerator from '../pages/Offer-Gen/OfferGenerator';
import OfferList from '../pages/Offer-Gen/OfferList';
import InterviewPanel from '../pages/Interview/InterviewPanel';
import RoleCreate from '../pages/Role_Layout/RoleCreate';
import InterviewView from '../pages/Interview/InterviewView';
import FeedbackView from '../pages/Interview/FeedbackViewer';
import Index from '../pages/_layout/AiVoiceInterview/VoiceInterview';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

const USERPROFILE = {
	BOXED: lazy(() => import('../pages/presentation/demo-pages/ProfilePage')),
};
const JOBREQUISITION = {
	JOB: lazy(() => import('../pages/presentation/demo-pages/JobRequistionPage')),
};
const JOBREQUISITIONForm = {
	JOBFORM: lazy(() => import('../pages/presentation/demo-pages/JobRequisitionFormPage')),
};
const CURRENTOPENINGS = {
	OPENINGS: lazy(() => import('../pages/presentation/demo-pages/CurrentOpennigsPage')),
};
const QUESTIONARIES = {
	QUESTIONARIES: lazy(() => import('../pages/presentation/demo-pages/QuestionariesPage')),
};
const REFERREDCANDIDATES = {
	REFERREDCANDIDATES: lazy(() => import('../pages/presentation/demo-pages/ReferredCandidatespage')),
};
const REQUIREMENT = {
	JD: lazy(() => import('../pages/presentation/demo-pages/RequirementPage')),
};
const ROLE = {
	FLUID: lazy(() => import('../pages/presentation/demo-pages/RoleManagePage')),
};
const UserManagement = {
	User: lazy(() => import('../pages/presentation/demo-pages/UserManagementPage')),
};
const OfferLists = {
	Offer: lazy(() => import('../pages/presentation/demo-pages/OfferListPage')),
};
const OfferSettings = {
	OfferSetting: lazy(() => import('../pages/presentation/demo-pages/OfferletterSettingPage')),
};
const FEEDBACKPARAMETER = {
	Feedback: lazy(() => import('../pages/presentation/demo-pages/FeedBackParameterPage')),
};
const SCHEDULEDINTERVIEWS = {
	Interviews: lazy(() => import('../pages/presentation/demo-pages/ScheduledInterviewsPage')),
};
const DETAILFEEDBACKPARAMETER = {
	Detail: lazy(() => import('../pages/presentation/demo-pages/DetailFeedBackPage')),
};
const FEEDBACKPARAMETERList = {
	FeedbackList: lazy(() => import('../pages/presentation/demo-pages/FeedBackPageList')),
};
const CANDIDATEVALUATION = {
	Evaluation: lazy(() => import('../pages/presentation/demo-pages/CandidateEvalutionPage')),
};
const CANDIDATEAPPLICATIONHISTORY = {
	History: lazy(() => import('../pages/presentation/demo-pages/CandidateHistoryPage')),
};
const CANDIDATEAPPLICATIONHISTORYVERTICAL = {
	VERTICAL: lazy(() => import('../pages/presentation/demo-pages/CandidateHistoryVerticalPage')),
};
const JobLists = {
	Job: lazy(() => import('../pages/presentation/demo-pages/JobListPage')),
};
const MODULE = {
	MANAGE: lazy(() => import('../pages/presentation/demo-pages/ModuleManagePage')),
};
const DEPARTMENT = {
	LIST: lazy(() => import('../pages/presentation/demo-pages/DepartmentManagePage')),
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const AIINTERVIEW = {
	INTERVIEW: lazy(() => import('../pages/presentation/demo-pages/AiInterviewPage')),
};

const CreateUser = {};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};
const isLogin = localStorage.getItem('HRMS-token');

const presentation = [
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
		protected: true,
	},
	{
		path: dashboardPagesMenu.role.path,
		// element: <RolePage isFluid />,
		element: <ROLE.FLUID />,
		protected: true,
	},
	{
		path: roleCreationMenu.roleCreate.path,
		element: <RoleCreate isFluid />,
		protected: true,
	},
	{
		path: `${roleCreationMenu.roleUpdate.path}`,
		element: <RoleCreate isFluid />,
		protected: true,
	},
	{
		path: profileMenu.profile.path,
		element: <USERPROFILE.BOXED />,
		protected: true,
	},
	{
		path: jobrequisitionMenu.JobRequisition.path,
		element: <JOBREQUISITION.JOB />,
		protected: true,
	},
	{
		path: jobRequisitionFormMenu.JobRequisitionForm.path,
		element: <JOBREQUISITIONForm.JOBFORM />,
		protected: true,
	},
	{
		path: jobrequisitionMenu.Requirement.path,
		element: <REQUIREMENT.JD />,
		protected: true,
	},

	{
		path: dashboardPagesMenu.moduleManage.path,
		element: <MODULE.MANAGE />,
	},
	{
		path: dashboardPagesMenu.DepartmentManage.path,
		element: <DEPARTMENT.LIST />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
		publicOnly: true,
	},
	{
		path: demoPagesMenu.logout.path,
		element: <Logout />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
		publicOnly: true,
	},
	{
		path: logoutMenu.logout.path,
		element: <Logout />,
	},
	// Page Layouts

	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
		protected: true,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
		protected: true,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
		protected: true,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
		protected: true,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
		protected: true,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
		protected: true,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
		protected: true,
	},
	{
		path: createUser.user.path,
		element: <UserCreate />,
		protected: true,
	},
	{
		path: createUser.userUpdate.path,
		element: <UserCreate />,
		protected: true,
	},
	{
		path: userManagement.user_list.path,
		// element: <UserTable isFluid />,
		element: <UserManagement.User />,
		protected: true,
	},
	{
		path: jobDescriptionMenu.job.path,
		element: <JobTemplate />,
		protected: true,
	},
	{
		path: `${jobDescriptionMenu.job.path}/:updateId`,
		element: <JobTemplate />,
		protected: true,
	},
	{
		path: jobrequisitionMenu.jobListPage.path,
		element: <JobLists.Job />,
		protected: true,
	},
	{
		path: OfferGenerateMenu.offerGeneratePage.path,
		element: <OfferGenerator isFluid />,
		protected: true,
	},
	{
		path: `${OfferGenerateMenu.offerGeneratePage.path}/:offerId`,
		element: <OfferGenerator isFluid />,
		protected: true,
	},
	{
		path: OfferListMenu.OfferListPage.path,
		// element: <OfferList isFluid />,
		element: <OfferLists.Offer />,
		protected: true,
	},
	{
		path: OfferListMenu.OfferSetting.path,
		element: <OfferSettings.OfferSetting />,
		protected: true,
	},
	{
		path: `${interviewPanelMenu.addInterview.path}/add-interview/:type/:id`,
		element: <InterviewPanel isFluid />,
		protected: true,
	},
	{
		path: `${interviewViewMenu.viewInterview.path}/:id`,
		element: <InterviewView isFluid />,
		protected: true,
	},
	{
		path: `${interviewViewMenu.feedbackView.path}/:roundType/:id`,
		element: <FeedbackView isFluid />,
		protected: true,
	},
	{
		path: FeedbackParameterMenu.FeedBackParameter.path,
		element: <FEEDBACKPARAMETER.Feedback />,
		protected: true,
	},
	{
		path: FeedbackParameterList.FeedBackParameterList.path,
		element: <FEEDBACKPARAMETERList.FeedbackList />,
		protected: true,
	},
	{
		path: FeedbackParameterMenu.DetailFeedbackParameter.path,
		element: <DETAILFEEDBACKPARAMETER.Detail />,
		protected: true,
	},
	{
		path: ScheduledInterviewsMenu.ScheduledInterviews.path,
		element: <SCHEDULEDINTERVIEWS.Interviews />,
		protected: true,
	},
	{
		path: CandidateEvaluationMenu.CandiddateEvaluation.path,
		element: <CANDIDATEVALUATION.Evaluation />,
		protected: true,
	},
	{
		path: `${CandidateApplicationHistory.CandiddateHistory.path}/:id`,
		element: <CANDIDATEAPPLICATIONHISTORY.History />,
		protected: true,
	},
	{
		path: CandidateApplicationHistory.CandiddateHistoryTimeLine.path,
		element: <CANDIDATEAPPLICATIONHISTORYVERTICAL.VERTICAL />,
		protected: true,
	},
	{
		path: CurrentOpeningsMenu.CurrentOpenings.path,
		element: <CURRENTOPENINGS.OPENINGS />,
		protected: true,
	},
	{
		path: QuestionariesListMenu.Questionaries.path,
		element: <QUESTIONARIES.QUESTIONARIES />,
		protected: true,
	},
	{
		path: ReferCandidatesList.ReferredCandiates.path,
		element: <REFERREDCANDIDATES.REFERREDCANDIDATES />,
		protected: true,
	},
	{
		path: AiVoiceInterview.AiVoiceInterview.path,
		element: <AIINTERVIEW.INTERVIEW />,
	},
];

const contents = [...presentation];

export default contents;
